import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import Loader from 'react-loader-spinner';
function ModalConfirmAssociateContact({
  show,
  onModalToggle,
  onConfirm,
  onCancel,
  contactName,
  accountName,
  message
}) {
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    if (submitting) return;
    onModalToggle(false);
    onCancel && onCancel();
  };

  const handleConfirm = async () => {
    try {
      setSubmitting(true);
      await Promise.resolve(onConfirm && onConfirm());
      onModalToggle(false);
    } finally {
      setSubmitting(false);
    }
  };

  const defaultMsg =
    message ||
    `Você deseja associar o contato atual${
      contactName ? ` “${contactName}”` : ''
    } à conta${accountName ? ` “${accountName}”` : ''}?`;

  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={show}
      returnFocusAfterClose={false}
      unmountOnClose={true}
      size="md"
      backdrop={submitting ? 'static' : true}
      keyboard={!submitting}
    >
      <div className="modal-header">
        <h6 className="modal-title">Associar contato à conta</h6>
        <button
          aria-label="Close"
          className="close"
          type="button"
          onClick={close}
          disabled={submitting}
        >
          <span aria-hidden={true}>&times;</span>
        </button>
      </div>

      <ModalBody>
        <p style={{ marginBottom: '1rem' }}>{defaultMsg}</p>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <ReactButton
            btnColor="confirmation"
            onClick={handleConfirm}
            disabled={submitting}
          >
            {submitting ? (
              <Loader type="TailSpin" height={18} width={18} />
            ) : (
              'Sim, associar'
            )}
          </ReactButton>

          <ReactButton
            btnColor="cancelation"
            onClick={close}
            disabled={submitting}
          >
            Não, continuar
          </ReactButton>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ModalConfirmAssociateContact;
